import Hero from "../components/Hero"
import Services from "../components/ServiceSec"
import Stats from "../components/Stats"
import WhyChooseUs from "../components/WhyChoose"
import ProductsSection from "../components/ProductsSection"
import Clients from "../components/Client"
import About from "../components/AboutSection"
import Contact from "../components/Contact"

function HomePage() {
  return (
    <>
      <Hero />
      <ProductsSection/>
      <Services />
      <Stats />
      <WhyChooseUs />
      {/* <ProductsSection /> */}
      <Clients />
      <About />
      <Contact />
    </>
  )
}

export default HomePage

